module.exports = __webpack_public_path__ + "static/media/sideBarLivecasino.ddfa583c.svg";